var _mask, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBagDistribution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_369_85",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12L6.83827 9.49026C6.46331 8.82366 6.94502 8 7.70985 8H13.2902C14.055 8 14.5367 8.82366 14.1617 9.49026L12.75 12"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37842 12.4903C7.64919 12.9716 8.2589 13.1423 8.74026 12.8716C9.22162 12.6008 9.39234 11.9911 9.12158 11.5097L7.37842 12.4903ZM11.8784 11.5097C11.6077 11.9911 11.7784 12.6008 12.2597 12.8716C12.7411 13.1423 13.3508 12.9716 13.6216 12.4903L11.8784 11.5097ZM14.1617 9.49026L13.2902 9L14.1617 9.49026ZM6.83827 9.49026L7.70985 9L6.83827 9.49026ZM9.12158 11.5097L7.70985 9L5.9667 9.98052L7.37842 12.4903L9.12158 11.5097ZM7.70985 9H13.2902V7H7.70985V9ZM13.2902 9L11.8784 11.5097L13.6216 12.4903L15.0333 9.98052L13.2902 9ZM13.2902 9H13.2902L15.0333 9.98052C15.7832 8.64731 14.8198 7 13.2902 7V9ZM7.70985 9L7.70985 9V7C6.1802 7 5.21677 8.64731 5.9667 9.98052L7.70985 9Z",
    fill: "#161616",
    mask: "url(#path-1-inside-1_369_85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54999 12.5H12.45C12.4609 12.5118 12.4723 12.5242 12.4843 12.5373C12.5997 12.6631 12.7654 12.8474 12.9647 13.0791C13.3637 13.543 13.8949 14.1941 14.4251 14.9438C14.9562 15.695 15.4797 16.536 15.8688 17.3802C16.2605 18.23 16.5 19.0488 16.5 19.7647C16.5 20.7214 16.1499 21.6256 15.2718 22.3051C14.3766 22.998 12.8766 23.5 10.5 23.5C8.12337 23.5 6.62345 22.998 5.72817 22.3051C4.85011 21.6256 4.5 20.7214 4.5 19.7647C4.5 19.0488 4.73948 18.23 5.13117 17.3802C5.5203 16.536 6.04379 15.695 6.57492 14.9438C7.10505 14.1941 7.63626 13.543 8.03531 13.0791C8.23459 12.8474 8.40031 12.6631 8.51567 12.5373C8.52766 12.5242 8.53911 12.5118 8.54999 12.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5H26.5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5L27 16.5L22 21.5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagDistribution);
export default __webpack_public_path__ + "static/media/BagDistribution.31b1807faf14f1b3513c3b24a90faded.svg";
export { ForwardRef as ReactComponent };